import React, {Component} from "react";
import Radium from "radium";
import DayPicker from "react-day-picker";
import {compose, values} from "ramda";
import {LocalDate} from "js-joda";
import { LIGHT_GREY } from "../styles";
import { LIGHT_TEXT_COLOR } from "../styles";

if (process.env.IS_IN_WEBPACK) {
    require("react-day-picker/lib/style.css");
    require("./DateRangeSelector.css");
}

const StyleConsts = { };
StyleConsts.timLightBlue = "#00acf0";
StyleConsts.strongTextColor = "black";
StyleConsts.menuStyles = {
    borderRadius: "0 3px 3px 3px",
    color: StyleConsts.strongTextColor,
    backgroundColor: LIGHT_GREY,
    position: "absolute",
    top: "25px",
    zIndex: 3,
    padding: "0.5em 1em 1em 1em",
    lineHeight: "18px",
    minWidth: "120px"
};
StyleConsts.triggerStyles = {
    cursor: "pointer",
    ":hover": {
        color: StyleConsts.timLightBlue
    }
};

export function RANGE_CUSTOM(from, to) {
    const fromStr = localDateToString(from);
    const toStr = localDateToString(to);
    return {
        type: "CUSTOM",
        name: `${fromStr} to ${toStr}`,
        range: { from, to }
    };
}

export const RANGE_BLANK = {type: "BLANK", name: "No range selected"}

export const RANGES = {
    //RANGE_ALL: { type: "ALL", name: "All" }
};

function dateToLocalDate(day) {
    //LocalDate.from(nativeJs(new Date()));
    return LocalDate.parse(day.toISOString().split("T")[0]);
}

function localDateToJSDate(day) {
    return day ? new Date(day.toString()) : undefined;
}

function localDateToString(day) {

    const month = day.month().toString();
    return `${day.dayOfMonth()}-${month.substr(0,1)}${month.substr(1,2).toLowerCase()}-${day.year().toString().substr(2,2)}`;
    // DateTimeFormatter.withPattern("d-MMM-yy").format(day);
}

class DateRangeSelector extends Component {

    constructor() {
        super();
        this._handleFromClick = this._handleFromClick.bind(this);
        this._handleToClick = this._handleToClick.bind(this);
        this._setRangeAndClose = this._setRangeAndClose.bind(this);
        this._isFromDate = this._isFromDate.bind(this);
        this._isToDate = this._isToDate.bind(this);
        this._isBeforeFromDate = this._isBeforeFromDate.bind(this);
        this._fromDateString = this._fromDateString.bind(this);
        this._toDateString = this._toDateString.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
    }

    render() {
        const highlightedStyles = {
            backgroundColor: StyleConsts.timLightBlue,
            ":hover": {
                color: "black"
            }
        };
        const hasRanges = values(RANGES).length > 0;
        return (
            <div ref="me" style={Object.assign({}, StyleConsts.menuStyles, {width: hasRanges ? 650 : 520, overflow: "auto"})}>
                {
                    hasRanges ?
                        <ul style={{float: "left", listStyleType: "none", padding: 0, width: 120, marginRight: 10}}>
                            { values(RANGES).map( range => (
                                <li key={range.type}
                                    className={`x-${range.type}`}
                                    style={Object.assign(
                                        {padding: "0.25em 0.35em", borderRadius: 4},
                                        StyleConsts.triggerStyles,
                                        this.props.timeframe.type === range.type && highlightedStyles)}
                                    onClick={() => this._setRangeAndClose(range) }>
                                    {range.name}
                                </li>
                            ))}
                        </ul>
                    : null
                }
                <div style={{float: "left"}}>
                    <div className="x-from" style={{float: "left", margin: "0 2em 0 0"}}>
                        <div><span style={{color: LIGHT_TEXT_COLOR}}>From:</span> <span className="x-from-text">{this._fromDateString()}</span></div>
                        <DayPicker
                            onDayClick={(e, day) => compose(this._handleFromClick, dateToLocalDate)(day)}
                            modifiers={{
                                isSelected: compose(this._isFromDate, dateToLocalDate),
                                isDisabled: compose(this._isOlderThanTwoYearsAgo, dateToLocalDate)
                            }}
                            initialMonth={localDateToJSDate(this.props.initialMonth) || this.props.timeframe.range && localDateToJSDate(this.props.timeframe.range.from)}
                        />
                    </div>
                    <div className="x-to" style={{float: "left"}}>
                        <div><span style={{color: LIGHT_TEXT_COLOR}}>To:</span> <span className="x-to-text">{this._toDateString()}</span></div>
                        <DayPicker
                            onDayClick={(e, day) => compose(this._handleToClick, dateToLocalDate)(day)}
                            modifiers={{
                                isSelected: compose(this._isToDate, dateToLocalDate),
                                isDisabled: day => {
                                    const localDate = dateToLocalDate(day);
                                    return this._isOlderThanTwoYearsAgo(localDate) || this._isBeforeFromDate(localDate)
                                }
                            }}
                            initialMonth={localDateToJSDate(this.props.initialMonth) || this.props.timeframe.range && localDateToJSDate(this.props.timeframe.range.to)}
                        />
                    </div>
                </div>

            </div>
        );
    }

    _isFromDate(day) {
        return this.props.timeframe.type === "CUSTOM" && day.equals(this.props.timeframe.range.from);
    }

    _isToDate(day) {
        return this.props.timeframe.type === "CUSTOM" && day.equals(this.props.timeframe.range.to);
    }

    _isBeforeFromDate(day) {
        return this.props.timeframe.type === "CUSTOM" && day.isBefore(this.props.timeframe.range.from);
    }

    _isOlderThanTwoYearsAgo(day) {
        const earliestDate = dateToLocalDate(new Date()).minusYears(2).minusDays(1);
        return day.isBefore(earliestDate);
    }

    _fromDateString() {
        return this.props.timeframe.type === "CUSTOM" ? localDateToString(this.props.timeframe.range.from) : "";
    }

    _toDateString() {
        return this.props.timeframe.type === "CUSTOM" ? localDateToString(this.props.timeframe.range.to) : "";
    }

    _handleFromClick(fromDay) {
        if (!this._isOlderThanTwoYearsAgo(fromDay)) {
            const range = this.props.timeframe.range;
            const validToDate = range && range.to && range.to >= fromDay;
            const toDay = validToDate ? range.to : fromDay;
            this.props.onSelect(RANGE_CUSTOM(fromDay, toDay));
        }
    }

    _handleToClick(toDay) {
        const range = this.props.timeframe.range;
        if ((!range || !toDay.isBefore(range.from)) && !this._isOlderThanTwoYearsAgo(toDay)) {
            this.props.onSelect(RANGE_CUSTOM(range && range.from || toDay, toDay));
        }
    }

    _setRangeAndClose(range) {
        this.props.onSelect(range);
        this.props.closeMenu();
    }

    componentDidMount() {
        document.addEventListener("click", this.handleDocumentClick, true);
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.handleDocumentClick, true);
    }

    handleDocumentClick(e) {
        const me = this.refs.me;

        if(!me) return;

        const outsideMe = !me.contains(e.target);

        if (outsideMe) {
            this.props.closeMenu();
        }
    }
}
DateRangeSelector.propTypes = {
    onSelect: React.PropTypes.func,
    timeframe: React.PropTypes.object
};

export default Radium(DateRangeSelector);



/** WEBPACK FOOTER **
 ** ./src/main/javascript/common/components/DateRangeSelector.js
 **/